import { PaymentMethodDTO } from 'core/api';
import * as Payment from './PrepaymentStatus';
import CreateAdvancedPaymentScreen from './CreateAdvancedPaymentScreen';
import { Modal } from 'core/ui-next/modal';
import { Result } from 'core/infrastructure';
import getTipData from 'pos/modules/main/direct-action/getTipData';

export default async function getAdvancedPaymentData(pendingAmount: number, paidAmount: number, method: PaymentMethodDTO, maxAvailableChange: number, imageSrc: string): Promise<Result<Payment.Status>> {

	const paymentDataResult = await Modal.show(CreateAdvancedPaymentScreen,
		{
			maxAvailableChange: maxAvailableChange,
			pendingAmount: pendingAmount,
			paidAmount: paidAmount,
			method: method,
			imageSrc: imageSrc
		});

	if (!paymentDataResult.ok)
		return Result.error();

	if (paymentDataResult.value.TipAmount !== 0)
		return Result.ok(paymentDataResult.value);

	const tipResult = await getTipData(paymentDataResult.value.PaidAmount, method);
	if (!tipResult.ok)
		return Result.error();

	paymentDataResult.value.TipAmount = tipResult.value;
	return Result.ok(paymentDataResult.value);
}